import { adminPaths } from "@app/routing/adminPaths";
import { useBreadcrumb } from "@app/shared/components/Breadcrumb/useBreadcrumb";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useParams } from "react-router-dom";
import { usePillars } from "../../data";
import "../../i18n";
import { RESOURCE_NAME, keys } from "../i18n";

export function useCsrdBreadcrumb() {
    const { t } = useTranslation(RESOURCE_NAME);
    const { pillar_id } = useParams();
    const {
        pillars: { byId: pillarsById },
    } = usePillars();

    const breadcrumbArgs = useMemo(() => {
        const currentPillar =
            pillar_id && pillar_id in pillarsById
                ? pillarsById[pillar_id]
                : null;

        return [
            adminPaths.framework_csrd_pillar_id_param,
            currentPillar?.name ?? "...",
        ] as const;
    }, [pillarsById, pillar_id]);

    const setBreadcumb = useBreadcrumb();

    useEffect(() => {
        const [path, name] = breadcrumbArgs;
        setBreadcumb(path, name);
        setBreadcumb(adminPaths.framework_csrd, t(keys.breadcrumb_csrd));
    }, [breadcrumbArgs, t, setBreadcumb]);
}
